import Vue from 'vue'
import Router from 'vue-router'
import store from '../store'
// import EditorView from '@/views/EditorView'
import EditorQuestionnaireView from '@/views/EditorQuestionnaireView'
// import ListView from '@/views/ListView'
import LayoutView from '@/views/LayoutView'
import LoginView from '@/views/LoginView'

Vue.use(Router)

// Rutas
const routes = [
  {
    path: '/',
    name: 'LayoutView',
    component: LayoutView,
    meta: { requiresAuth: true }
  },
  {
    path: '/editor/:formId',
    name: 'EditorQuestionnaireView',
    component: EditorQuestionnaireView,
    meta: { requiresAuth: true }
  },
  {
    path: '/login',
    name: 'Login',
    component: LoginView
  }
]

const router = new Router({
  routes
})

// authentication
router.beforeEach(async (to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    const isAuthenticated = store.getters.isAuthenticated
    const accessToken = isAuthenticated.accessToken
      ? isAuthenticated.accessToken
      : localStorage.getItem('accesToken')

    let validate = accessToken !== null
      ? await store.dispatch('validateAccessToken', accessToken)
      : {success: false}

    if (validate.success === true) next()
    else next('/login')
  } else {
    next()
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js